<script setup lang="ts">
import HeaderSection from '@/components/contact/HeaderSection.vue'
import SideChanger from '@/components/SideChanger.vue'
import { Routes, RoutesName } from '@/enums/Routes'
import { useContactStore } from '@/store/contact.store'
import { ApplicationMode } from '@/enums/ApplicationMode'

useHead({ title: RoutesName.CONTACT })

const sideChanger = useContactStore().getSideChanger

const prev = {
  title: sideChanger?.leftText ?? '',
  section: RoutesName.PORTFOLIO,
  route: Routes.PORTFOLIO,
}
const next = {
  title: sideChanger?.rightText ?? '',
  section: RoutesName.HOME,
  route: Routes.HOME,
}
</script>
<template>
  <div>
    <HeaderSection :mode="ApplicationMode.Header" />
    <SideChanger v-if="sideChanger" :prev="prev" :next="next" />
  </div>
</template>
